import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth, useTier } from '../context/AuthContext';
import { colors } from '../lib/theme';
import SideMenu from './SideMenu';

const links: { to: string; label: string; end?: boolean; proOnly?: boolean }[] = [
  { to: '/', label: 'Meal', end: true },
  { to: '/dishes', label: 'Menu' },
  { to: '/products', label: 'Products' },
  { to: '/shopping-list', label: 'Shopping List', proOnly: true },
];

function getInitials(name: string | null, email: string): string {
  if (name && name.trim()) {
    const parts = name.trim().split(/\s+/);
    const initials = parts.length > 1 ? parts[0][0] + parts[parts.length - 1][0] : parts[0].slice(0, 2);
    return initials.toUpperCase();
  }
  return email.slice(0, 2).toUpperCase();
}

export default function NavBar() {
  const { user } = useAuth();
  const tier = useTier();
  const [menuOpen, setMenuOpen] = useState(false);
  const visibleLinks = links.filter((link) => !link.proOnly || tier === 'PRO');

  if (!user) {
    return (
      <div
        style={{
          textAlign: 'center',
          padding: '1.5rem 1rem 0.5rem',
          maxWidth: 720,
          margin: '0 auto',
        }}
      >
        <div style={{ fontSize: '1.4rem', fontWeight: 700, color: '#1a1815' }}>DishSensei</div>
        <div style={{ fontSize: '0.8rem', opacity: 0.6 }}>dishsensei.com</div>
      </div>
    );
  }

  return (
    <>
      <nav
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          padding: '1rem',
          borderBottom: '1px solid #e0ddd7',
          maxWidth: 720,
          margin: '0 auto',
        }}
      >
        {visibleLinks.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            style={({ isActive }) => ({
              textDecoration: 'none',
              color: isActive ? '#1a1815' : '#8a8578',
              fontWeight: isActive ? 600 : 400,
            })}
          >
            {link.label}
          </NavLink>
        ))}

        <div style={{ flex: 1 }} />

        <button
          onClick={() => setMenuOpen(true)}
          aria-label="Open profile menu"
          style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            border: 'none',
            cursor: 'pointer',
            background: colors.lavender,
            color: colors.lavenderText,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            padding: 0,
            overflow: 'hidden',
          }}
        >
          {user.avatarUrl ? (
            <img
              src={user.avatarUrl}
              alt=""
              width={36}
              height={36}
              style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover' }}
            />
          ) : (
            <span style={{ fontSize: '0.85rem', fontWeight: 700 }}>{getInitials(user.name, user.email)}</span>
          )}
        </button>
      </nav>

      <SideMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
    </>
  );
}
